import styled from "styled-components";

const COLS = "80px 180px 160px 160px 160px auto";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const SkeletonMenu = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.interfacePure100};
`;

export const SkeletonTabs = styled.div`
    width: 415px;
    min-width: 280px;
    height: 40px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.interfacePure100};
    opacity: 0.7;
`;

export const SkeletonSearch = styled.div`
    width: 280px;
    height: 40px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.interfacePure100};
    opacity: 0.7;
`;

export const SkeletonTableContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const SkeletonCard = styled.div`
    display: grid;
    grid-template-columns: ${COLS};
    gap: 0 24px;
    align-items: center;
    width: 100%;
    height: 80px;
    padding-left: 24px;
    padding-right: 16px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.interfacePure0};
    box-shadow: 35px 45px 73px rgba(32, 32, 35, 0.07);

    & > *:nth-child(1) { grid-column: 1; }
    & > *:nth-child(2) { grid-column: 2; }
    & > *:nth-child(3) { grid-column: 3; }
    & > *:nth-child(4) { grid-column: 4; }
    & > *:nth-child(5) { grid-column: 5; }
    & > *:nth-child(6) { grid-column: 6; }
`;

export const SkeletonIcon = styled.div`
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.interfacePure100};
    opacity: 0.8;
`;

export const SkeletonPlano = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;

    .line-title {
        width: 40%;
        height: 12px;
        border-radius: 4px;
        background: ${({ theme }) => theme.colors.interfacePure100};
        opacity: 0.8;
    }
    .line-subtitle {
        width: 70%;
        height: 14px;
        border-radius: 4px;
        background: ${({ theme }) => theme.colors.interfacePure100};
        opacity: 0.8;
    }
`;

export const SkeletonBar = styled.div<{ width?: string }>`
    height: 14px;
    width: ${({ width }) => width ?? "80%"};
    max-width: 100%;
    border-radius: 4px;
    background: ${({ theme }) => theme.colors.interfacePure100};
    opacity: 0.8;
`;

export const SkeletonActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 9px;
`;

export const SkeletonBadge = styled.div`
    width: 48px;
    height: 24px;
    border-radius: 12px;
    background: ${({ theme }) => theme.colors.interfacePure100};
    opacity: 0.8;
`;

export const SkeletonButton = styled.div`
    width: 36px;
    height: 36px;
    min-width: 36px;
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.interfacePure100};
    opacity: 0.8;
`;
